/**
 * ProductShare Custom Element
 * Zero-dependency share widget for the product title:
 * - Native OS share sheet (covers Messenger/Instagram Direct on mobile) with copy-link fallback
 * - Facebook share dialog (includes a "Send in Messenger" option)
 * - Instagram: copies the product link (no official web share endpoint) and opens Instagram
 */

class ProductShare extends HTMLElement {
  #toastTimer = null;

  connectedCallback() {
    this.url = this.dataset.url;
    this.title = this.dataset.title;
    this.toast = this.querySelector('[data-share-toast]');

    this.querySelector('[data-share-native]')?.addEventListener('click', this.#onNativeShare.bind(this));
    this.querySelector('[data-share-facebook]')?.addEventListener('click', this.#onFacebookShare.bind(this));
    this.querySelector('[data-share-instagram]')?.addEventListener('click', this.#onInstagramShare.bind(this));
  }

  async #onNativeShare() {
    if (navigator.share) {
      try {
        await navigator.share({ title: this.title, url: this.url });
      } catch (error) {
        // User cancelled the native share sheet - nothing to do.
      }
      return;
    }
    this.#copyLink();
  }

  #onFacebookShare() {
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.url)}`;
    window.open(shareUrl, 'share-facebook', 'width=600,height=520,noopener,noreferrer');
  }

  #onInstagramShare() {
    this.#copyLink();
    window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
  }

  async #copyLink() {
    try {
      await navigator.clipboard.writeText(this.url);
    } catch (error) {
      const input = document.createElement('input');
      input.value = this.url;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    this.#showToast();
  }

  #showToast() {
    if (!this.toast) return;
    this.toast.hidden = false;
    clearTimeout(this.#toastTimer);
    this.#toastTimer = setTimeout(() => {
      this.toast.hidden = true;
    }, 2500);
  }
}

customElements.define('product-share', ProductShare);
